import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/uu-dai" element={<Home />} />
          <Route path="/phi-re" element={<Home />} />
          <Route path="/rut-online" element={<Home />} />
          <Route path="/uu-dai-2" element={<Home />} />
          <Route path="/uy-tin" element={<Home />} />
          <Route path="/bang-phi" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
